import { render, staticRenderFns } from "./testdata.vue?vue&type=template&id=200f7ca0&scoped=true&"
import script from "./testdata.vue?vue&type=script&lang=js&"
export * from "./testdata.vue?vue&type=script&lang=js&"
import style0 from "./testdata.vue?vue&type=style&index=0&id=200f7ca0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f7ca0",
  null
  
)

export default component.exports